
































































































































































































































import Button from '@/app/ui/components/Button/index.vue'
import CloseLine from '@/app/ui/assets/close_line.vue'
import IcsFProfile from '@/app/ui/assets/ics_f_profile.vue'
import IcsFPhone from '@/app/ui/assets/ics_f_phone.vue'
import IcsFLocationPin from '@/app/ui/assets/ics_f_location_pin.vue'
import IcsOBikeBlack from '@/app/ui/assets/ics_o_bike_black.vue'
import EyeIcon from '@/app/ui/assets/eye.vue'
import EyeDisabledIcon from '@/app/ui/assets/eye_disabled.vue'
import PriorityIcon from '@/app/ui/assets/ics_f_priority-fast.vue'
import { comparePickupCrrotwShipmentIdAsc } from '@/app/infrastructures/misc/pickupCrrotw'
import {
  PickupCRROTWV2Group,
  PickupCRROTWV2ShipmentDetail,
} from '@/domain/entities/Pickup'
import PickupController from '@/app/ui/controllers/PickupController'
import dayjs from 'dayjs'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
  components: {
    Button,
    CloseLine,
    IcsFProfile,
    IcsFPhone,
    IcsFLocationPin,
    IcsOBikeBlack,
    EyeIcon,
    EyeDisabledIcon,
    PriorityIcon,
  },
})
class ShipmentListModal extends Vue {
  @Prop({ default: false }) visible!: boolean
  @Prop({ default: null }) groupData!: PickupCRROTWV2Group | null
  @Prop({ default: 0 }) nowTick!: number

  controller = PickupController
  phoneRevealed = false
  addressRevealed = false
  group: PickupCRROTWV2Group | null = null;

  get listRows(): PickupCRROTWV2ShipmentDetail[] {
    if (!this.group?.shipments?.length) return []
    return [...this.group.shipments].sort(comparePickupCrrotwShipmentIdAsc)
  }

  get emptyMessage(): string {
    if (!this.group) return ''
    const total = Number(this.group.totalShipments) || 0
    if (total > 0 && this.listRows.length === 0) {
      return 'Daftar shipment kosong sementara total menunjukkan ada paket. Data mungkin belum sinkron — coba sync ulang atau laporkan ke tim teknis.'
    }
    return 'Tidak ada shipment untuk grup ini.'
  }

  get posLabel(): string {
    const g = this.group
    if (!g) return '—'
    const code = (g.agent?.code || '').replace(/^["']+|["']+$/g, '').trim()
    if (code) {
      return `[${code}] ${g.agent?.name || ''}`.trim()
    }
    return g.agent?.name || '—'
  }

  get courierLines(): string[] {
    const g = this.group
    if (!g) return ['—']
    const c = g.courier
    const typePart = c.type ? ` (${c.type})` : ''
    const posLabel = this.posLabel

    if (g.executionPlatform === 'FLEET_APPS' && c.drivers && c.drivers.length > 0) {
      return c.drivers.map(d => {
        const phone = this.formatPhoneDisplay(d.phoneNumber)
        const phonePart = phone ? ` (${phone})` : ''
        return `[${d.id}] ${d.name || ''}${typePart}${phonePart} • ${posLabel}`
      })
    }

    const phone = this.formatPhoneDisplay(c.phoneNumber)
    const phonePart = phone ? ` ${phone}` : ''
    return [`[${c.id}] ${c.name || ''}${typePart}${phonePart} • ${posLabel}`]
  }

  get courierLine(): string {
    return this.courierLines.join('\n')
  }

  get shouldShowCountdown(): boolean {
    if (!this.group?.expiredAt) return false
    return dayjs(this.group.expiredAt).valueOf() > this.nowTick
  }

  get isSlaUrgent(): boolean {
    if (!this.group?.expiredAt) return false
    const end = dayjs(this.group.expiredAt)
    const m = end.diff(dayjs(this.nowTick), 'minute', true)
    return m >= 0 && m < 30
  }

  get formatCountdown(): string {
    if (!this.group?.expiredAt) return '—'
    const end = dayjs(this.group.expiredAt).valueOf()
    const ms = end - this.nowTick
    if (ms <= 0) return '00 : 00 : 00'
    const totalSec = Math.floor(ms / 1000)
    const h = Math.floor(totalSec / 3600)
    const mi = Math.floor((totalSec % 3600) / 60)
    const s = totalSec % 60
    const pad = (x: number) => String(x).padStart(2, '0')
    return `${pad(h)} : ${pad(mi)} : ${pad(s)}`
  }

  public mapsHref(address: string): string {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      address || ''
    )}`
  }

  public waDigits(phone: string): string {
    return String(phone || '').replace(/\D/g, '')
  }

  public formatPhoneDisplay(phone: string): string {
    const raw = String(phone || '').trim()
    if (!raw) return ''
    const d = this.waDigits(raw)
    if (!d) return raw
    if (raw.startsWith('+')) return `+${d}`
    if (d.startsWith('62')) return `+${d}`
    if (d.startsWith('0')) return `+62${d.slice(1)}`
    return `+${d}`
  }

  created(): void {
    if (this.visible && this.groupData) {
      this.group = { ...this.groupData } as PickupCRROTWV2Group
    }
  }

  @Watch('visible')
  onVisibleChange(): void {
    if (this.visible) {
      this.phoneRevealed = false
      this.addressRevealed = false
      this.group = { ...this.groupData } as PickupCRROTWV2Group
    }
  }

  @Watch('groupData', { deep: true })
  onGroupDataChange(): void {
    if (this.visible && this.groupData) {
      this.group = { ...this.groupData } as PickupCRROTWV2Group
    }
  }

  async showPhone(): Promise<void> {
    const g = this.group
    if (!g) return
    const isFleetApps = g.executionPlatform === 'FLEET_APPS'
    try {
      const resp = await this.controller.adminContactShow({
        resource: (g.shipperHash && !isFleetApps) ? 'shipper_hash' : 'shipment',
        resourceId: (!isFleetApps && g.shipperHash) ? g.shipperHash : g.shipments[0]?.shipmentId,
        field: 'sender_phone',
        source: 'pickup_crrotwv2_modal_list'
      })
      g.senderPhone = resp.value || '-'
    } finally {
      /* revealed regardless */
    }
    this.phoneRevealed = true
  }

  hidePhone(): void {
    this.phoneRevealed = false
  }

  async showAddress(): Promise<void> {
    const g = this.group
    if (!g) return
    const isFleetApps = g.executionPlatform === 'FLEET_APPS'
    try {
      const resp = await this.controller.adminContactShow({
        resource: (g.shipperHash && !isFleetApps) ? 'shipper_hash' : 'shipment',
        resourceId: (!isFleetApps && g.shipperHash) ? g.shipperHash : g.shipments[0]?.shipmentId,
        field: 'sender_address',
        source: 'pickup_crrotwv2_modal_list'
      })
      g.senderAddress = resp.value || '-'
    } finally {
      /* revealed regardless */
    }
    this.addressRevealed = true
  }

  hideAddress(): void {
    this.addressRevealed = false
  }

  public onClose(): void {
    this.$emit('close')
  }
}

export default ShipmentListModal;
